import { render, staticRenderFns } from "./CepManagerElectionsSummary.vue?vue&type=template&id=4b5bec8e&scoped=true&"
import script from "./CepManagerElectionsSummary.vue?vue&type=script&lang=js&"
export * from "./CepManagerElectionsSummary.vue?vue&type=script&lang=js&"
import style0 from "./CepManagerElectionsSummary.vue?vue&type=style&index=0&id=4b5bec8e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5bec8e",
  null
  
)

export default component.exports